import React, { useState } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { Asset } from "contentful";
import { Theme } from "@literati/public-ui-shared-react";
import analytics from "analytics";
import { SubscriptionShippingWindow } from "@literati/kids-api";
import { getAbbrevDeliveryDateString } from "utils/date";
import StepLayout from "components/Step/StepLayout";
import OnboardingConfirmationContent from "components/Onboarding/OnboardingConfirmationContent";

const FOOTER_LABEL = "Continue to My Account";

const StyledOnboardingConfirmationContent = styled(
  OnboardingConfirmationContent
)`
  padding: 2rem 1rem 0;
`;

/**
 * @note - component will choose `deliveryDate` over `shippingWindow` for backwards compatibility.
 */
export interface StepConfirmationOnboardingProps {
  deliveryDate?: string | null;
  readingLevelImage?: Asset["fields"];
  shippingWindow?: SubscriptionShippingWindow | null;
}

export const StepConfirmationOnboarding = ({
  deliveryDate,
  readingLevelImage,
  shippingWindow,
}: StepConfirmationOnboardingProps) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    analytics.trackAmplitudeClickEvent(FOOTER_LABEL);
    router?.push("/account/boxes");
  };

  const dateFromWindow = shippingWindow
    ? getAbbrevDeliveryDateString(shippingWindow)
    : null;
  const _deliveryDate = deliveryDate ?? dateFromWindow;

  return (
    <Theme>
      <StepLayout
        asForm={false}
        bgColor="white"
        disableContentSpacing
        stepHeaderProps={{
          suppressBackButton: true,
        }}
        stepFooterProps={{
          nextButtonProps: {
            loading,
            onClick: handleClick,
            children: FOOTER_LABEL,
          },
          suppressBackButton: true,
        }}
      >
        <StyledOnboardingConfirmationContent
          deliveryDate={_deliveryDate}
          readingLevelImage={readingLevelImage}
        />
      </StepLayout>
    </Theme>
  );
};

export default StepConfirmationOnboarding;
